module.exports = __webpack_public_path__ + "img/1-3.e117cbd5.png";